/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchGuidanceOverview } from '../actions/careerGuidance';

// Single source of truth for the candidate-side guidance overview. Populated by
// whichever surface fetches it (dashboard promo, sidebar link, the hub page), so
// the sidebar can gate its link on eligibility without its own bespoke fetch.
interface CareerGuidanceState {
  overview: any | null;
  isFetching: boolean;
  fetched: boolean;
}

const initialState: CareerGuidanceState = {
  overview: null,
  isFetching: false,
  fetched: false,
};

const careerGuidanceSlice = createSlice({
  name: 'careerGuidance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGuidanceOverview.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchGuidanceOverview.fulfilled, (state, action) => {
        state.isFetching = false;
        state.fetched = true;
        state.overview = action.payload ?? null;
      })
      .addCase(fetchGuidanceOverview.rejected, (state) => {
        state.isFetching = false;
        state.fetched = true;
      });
  },
});

export default careerGuidanceSlice.reducer;
